export enum FilterByLevel {
  Zero = 'Нулевой',
  Hobby = 'Любительский',
  Professional = 'Профессиональный'
}
